// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sa6K","type":"styles_type__3YZiJ","choices":"styles_choices__ySS5C"};